<h2 mat-dialog-title>Thank You!</h2>
<mat-dialog-content class="mat-typography">
    <p>
        Your review has been saved!
    </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</mat-dialog-actions>